import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function startGeneration(prompt) {
  const response = await axios.post(`${API}/generate`, { prompt }, { timeout: 15000, withCredentials: true });
  return response.data;
}

export async function pollGeneration(jobId) {
  const response = await axios.get(`${API}/generate/${jobId}`, { timeout: 10000, withCredentials: true });
  return response.data;
}

export function getExportUrl(jobId, format) {
  return `${API}/export/${jobId}/${format}`;
}

export async function getHistory() {
  const response = await axios.get(`${API}/billing/history`, { timeout: 10000, withCredentials: true });
  return response.data;
}

export async function getBalance() {
  const response = await axios.get(`${API}/billing/balance`, { timeout: 10000, withCredentials: true });
  return response.data;
}
